import styled from 'styled-components';
import theme from '../../themes/main';
import { isIE } from '../../utils/helper';

export const FooterContainer = styled.footer`
  align-items: center;
  background-color: ${theme.palette.black};
  color: white;
  display: flex;
  height: 80px;
  justify-content: center;
  ${() => isIE() ? `flex-shrink: 0;` :``}
`;



// WEBPACK FOOTER //
// ./src/components/Footer/styledComponents.js